<template>
    <div class="header">
        <div class="logo">
            <div class="background-container">
            </div>
            <h1 class="text-shadow">Lorena Lunetta</h1>
            <h2 class="text-shadow">Digital Art / Epoxy Art / Painting / Drawing</h2>
        </div>
        <Navigation :links="store.Navigation">
        </Navigation>
        <div class="header-image">
        </div>
    </div>
</template>

<script>
    import Navigation from "@/components/Navigation.vue";
    import store from "@/store";

    export default {
        name: 'Header',
        props: {
        },
        components: {
            Navigation
        },
        data: function () {
            return {
                store: store
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1 {
        font-weight: normal;
        font-size: 40px;
    }

    .logo h1 {
        font-weight: bold;
        font-size: 40px;
    }

    .logo h2 {
        font-size: 30px;
    }

    @media screen and (max-width: 600px) {
        .logo h1 {
            font-weight: bold;
            font-size: 20px;
        }

        .logo h2 {
            font-size: 16px;
        }
    }

    .logo {
        padding: 20px;
        text-align: center;
    }

    .header {
        padding-top: 100px;
    }

    .background-container {
        background-image: url(../assets/home-banner.jpg);
        height: 300px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        position: relative;
    }

    .text-shadow {
        text-shadow: 1px 1px 3px #000;
    }

    @media screen and (min-width: 1024px) {
        .background-container {
            height: 500px;
        }
    }

    .v-center {
        transform: translateY(-50%) translateX(-50%);
        position: absolute;
        top: 50%;
        left: 50%;
    }
</style>
